<ion-header>
  <ion-toolbar>
    <ion-title>
      {{ 'me.fit.copilot' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="configure()">
        <ion-icon name="settings-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="collapsePane()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="messages$ | async as messages">
    <ion-card
      *ngFor="let msg of messages"
      class="chat-bubble"
      [class.user-message]="msg.role === 'user'"
      [class.ai-message]="msg.role === 'assistant'"
      [class.ai-message]="msg.role === 'system'"
    >
      <span class="message-text">
        {{ msg.content.text }}

        <small *ngIf="msg.role === 'system'">
          (System Message)
        </small>
      </span>
    </ion-card>

    <ion-card class="chat-bubble ai-message ion-no-margin ion-padding" *ngIf="loading$ | async">
      <div class="chat-bubble-inner">
        <ion-spinner></ion-spinner>
      </div>
    </ion-card>
  </div>
</ion-content>

<ion-footer class="ion-padding">
  <form *ngIf="fields$ | async as fields" [formGroup]="aiForm" (ngSubmit)="submit()">
    <ion-item fill="outline" lines="none">
      <ion-textarea
        rows="4"
        formControlName="aiPrompt"
        [placeholder]="fields.promptPlaceholder"
        (keydown)="onTextareaKeydown($event)"
      >
      </ion-textarea>
    </ion-item>
    <ion-row class="ion-align-items-center ion-margin-top send-button-row">

      <ion-item fill="outline" lines="none">
        <ion-select
          labelPlacement="floating"
          [label]="'copilot.model' | translate"
          [formControl]="aiForm.controls['model']"
          interface="popover"
          [interfaceOptions]="{size: 'auto'}">
          <ion-select-option *ngFor="let model of modelOptions$ | async" [value]="model.value">
            {{ model.name }} ({{ model.pricing }})
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-button
        color="secondary"
        type="submit"
        [attr.aria-label]="fields.buttonLabel"
        [attr.title]="fields.buttonLabel"
      >
        <ion-icon name="send-outline"></ion-icon>
      </ion-button>

    </ion-row>
  </form>
  <ng-container *ngIf="(contextButtons$ | async)?.length">
    <ion-button *ngFor="let button of (contextButtons$ | async)" expand="block" class="ion-margin-top" (click)="onContextButtonClick(button)">
      {{ button.label }}
    </ion-button>
  </ng-container>
</ion-footer>
